import { supabase } from '@/lib/supabase'

// ── Admin prize management ─────────────────────────────────────────

export async function fetchPrizes({ p_search_term = null, p_tournament_id = null, p_group_id = null, p_has_winner = null }) {
  const { data, error } = await supabase.rpc('get_prizes', {
    p_search_term,
    p_tournament_id,
    p_group_id,
    p_has_winner,
  })
  if (error) throw error
  return data
}

export async function upsertPrize({ p_id, p_tournament_id, p_bracket_id, p_group_id, p_name, p_description, p_place, p_promo_code, p_redeem_url, p_combined_redeem_url }) {
  const { data, error } = await supabase.rpc('upsert_prize', {
    p_id,
    p_tournament_id,
    p_bracket_id,
    p_group_id,
    p_name,
    p_description,
    p_place,
    p_promo_code,
    p_redeem_url,
    p_combined_redeem_url,
  })
  if (error) throw error
  return data
}

export async function deletePrize({ p_prize_id }) {
  const { error } = await supabase.rpc('delete_prize', {
    p_prize_id,
  })
  if (error) throw error
}

// Replaces the prize's winner set. Several ids = a tie; [] clears it.
export async function assignPrizeWinners({ p_prize_id, p_winner_user_ids }) {
  const { data, error } = await supabase.rpc('assign_prize_winners', {
    p_prize_id,
    p_winner_user_ids: p_winner_user_ids || [],
  })
  if (error) throw error
  return data
}

export async function searchUsersForPrize({ p_query, p_group_id = null, p_limit = 10 }) {
  const { data, error } = await supabase.rpc('search_users', {
    p_query,
    p_group_id,
    p_limit,
  })
  if (error) throw error
  return data
}

export async function fetchTournaments({ p_search_term = null, p_sport_id = null, p_status = null, p_start_date_from = null, p_start_date_to = null, p_group_id = null }) {
  const { data, error } = await supabase.rpc('get_tournaments', {
    p_search_term,
    p_sport_id,
    p_status,
    p_start_date_from,
    p_start_date_to,
    p_group_id,
  })
  if (error) throw error
  return data
}

export async function fetchGroups() {
  const { data, error } = await supabase
    .from('groups')
    .select('id, name')
    .order('name')
  if (error) throw error
  return data
}

export async function fetchBracketsForTournament(tournamentId) {
  const { data, error } = await supabase
    .from('brackets')
    .select('id, division_id, divisions(name, gender, team_size)')
    .eq('tournament_id', tournamentId)
  if (error) throw error
  return data
}

export async function searchGroupsForFilter(query) {
  const { data, error } = await supabase
    .from('groups')
    .select('id, name')
    .ilike('name', `%${query}%`)
    .order('name')
    .limit(10)
  if (error) throw error
  return data
}

// ── Player-facing prizes ───────────────────────────────────────────

export async function fetchMyPrizes() {
  const { data, error } = await supabase.rpc('get_my_prizes')
  if (error) throw error
  return data
}

export async function claimPrize({ p_prize_id }) {
  const { data, error } = await supabase.rpc('claim_prize', {
    p_prize_id,
  })
  if (error) throw error
  return data
}
